import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import { AuthShell, Field } from "./Login";

const btn = "w-full py-3 rounded-full bg-wyd-accent text-wyd-bg font-semibold hover:glow-magenta transition-shadow duration-300 disabled:opacity-60";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Password dimenticata" subtitle="Ti mandiamo un link per sceglierne una nuova">
      {sent ? (
        <div data-testid="forgot-success" className="text-center py-4">
          <MailCheck className="mx-auto text-wyd-accent" size={36} />
          <p className="mt-4 text-wyd-muted text-sm leading-relaxed">
            Se <span className="text-white">{email}</span> è registrata, riceverai a breve un'email con il link. Il link vale 1 ora.
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Field label="Email" type="email" value={email} onChange={setEmail} testid="forgot-email" />
          {error && <p data-testid="forgot-error" className="text-sm text-red-300">{error}</p>}
          <button data-testid="forgot-submit" disabled={loading} className={btn}>{loading ? "Invio..." : "Invia link"}</button>
        </form>
      )}
      <p className="mt-6 text-sm text-wyd-muted text-center">
        <Link to="/login" data-testid="forgot-back-login" className="text-wyd-accent font-medium">Torna all'accesso</Link>
      </p>
    </AuthShell>
  );
}
